import * as React from "react";
const IconTrashCan = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M48.9 8.8h-7.7V7.1c0-3-2.4-5.4-5.4-5.4h-7.7c-3 0-5.4 2.4-5.4 5.4v1.7H15c-2.9 0-5.3 2.4-5.3 5.3v3c0 2.2 1.3 4 3.2 4.8l1.6 34.6c.2 3.3 2.8 5.8 6.1 5.8h22.5c3.3 0 6-2.6 6.1-5.8L51 21.8c1.9-.8 3.2-2.7 3.2-4.8v-3c0-2.8-2.4-5.2-5.3-5.2M27.3 7.1c0-.5.4-.9.9-.9h7.7c.5 0 .9.4.9.9v1.7h-9.4V7.1zm-13 7c0-.4.3-.8.8-.8h33.8c.4 0 .8.3.8.8v3c0 .4-.3.8-.8.8H15.1c-.4 0-.8-.3-.8-.8zm28.9 43.7H20.8c-.9 0-1.6-.7-1.6-1.5l-1.6-33.9h28.9l-1.6 33.9c-.1.8-.8 1.5-1.7 1.5" />
    <path d="M32 32.4c-1.2 0-2.3 1-2.3 2.3v12.7c0 1.2 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3V34.7c0-1.3-1.1-2.3-2.3-2.3M40 34.4c-1.3-.1-2.3.8-2.4 2.1l-.6 8.8c-.1 1.2.8 2.3 2.1 2.4h.2c1.2 0 2.2-.9 2.2-2.1l.6-8.8c0-1.3-.9-2.3-2.1-2.4M23.9 34.4c-1.2.1-2.2 1.2-2.1 2.4l.7 8.8c.1 1.2 1.1 2.1 2.2 2.1h.2c1.2-.1 2.2-1.2 2.1-2.4l-.7-8.8c0-1.3-1.1-2.2-2.4-2.1" />
  </svg>
);
export default IconTrashCan;
